export default __webpack_public_path__ + "static/media/fw-jasna.63385c52.jpg";